import {
  RtFraction,
  RtPositiveInteger,
  RtWithFundingType,
  RtWithName,
  RtWithProjectionPeriods,
  RtWithRelativesSet,
} from "@aprao/common/src/runtypes/common.js";
import { z } from "zod";

import { WithTimelineOverrideSchema } from "./TimelineStageSchema.js";

export const RtBuildPhaseCostsKeys = z.enum([
  "absolute",
  "ratioGrossArea",
  "ratioQuantity",
]);
const RtBuildPhaseContingencyKeys = z.enum(["absolute", "ratioGrossCost"]);
const RtBuildPhaseGrossAreaKeys = z.enum(["absolute", "ratioNetArea"]);

export const RtBuildPhase = z
  .object({
    /**
     * An "unique" id that can be used to link it to revenue groups.
     */
    refId: z.string(),
    name: z.string(),
    grossArea: RtWithRelativesSet(RtBuildPhaseGrossAreaKeys),
    definedNetArea: RtFraction.nullable(),
    definedSalesItemsQuantity: RtPositiveInteger.nullable(),
    costs: z.array(RtWithRelativesSet(RtBuildPhaseCostsKeys).merge(RtWithName)),
    contingency: RtWithRelativesSet(RtBuildPhaseContingencyKeys),
  })
  .merge(RtWithFundingType)
  .merge(RtWithProjectionPeriods)
  .merge(WithTimelineOverrideSchema);
